import './assets/ContentCard.css';const o = "#ffffff", a = "#396e75", t = "#e5fdff", n = "#546223", e = "#f0fae5", r = "#a65523", d = "#fff1e8", i = "#7f3e3e", c = "#ffe2e2", s = "#62625a", l = "#f8f8e7", _ = "#38539a", g = "#707070", k = "#c8f8d1", C = "#87c9c8", f = "#5291b1", z = "rgba(82, 145, 177, 0.1019607843)", V = "#445685", b = "#181d61", h = "rgba(24, 29, 97, 0.1019607843)", y = "#5969d6", x = "#ea999d", u = "#b6577e", m = "rgba(182, 87, 126, 0.1019607843)", B = "#7e3e80", O = "#1e247f", W = "rgba(30, 36, 127, 0.1019607843)", v = "#da7600", G = "#107f47", w = "#d91734", I = "_html_yxkbo_46", R = "_contentCard_yxkbo_80", P = "_cardContainer_yxkbo_93", Y = "_thumbnailContainer_yxkbo_102", p = "_noImageContainer_yxkbo_110", F = "_noImage_yxkbo_110", H = "_offerWidth_yxkbo_141", A = "_container_yxkbo_144", S = "_content_yxkbo_80", j = "_tag_yxkbo_155", q = "_title_yxkbo_176", D = "_details_yxkbo_194", E = "_cardFooter_yxkbo_216", J = "_divider_yxkbo_233", K = "_dot_yxkbo_238", L = "_searchPage_yxkbo_241", M = "_offers_yxkbo_270", N = "_searchOverlay_yxkbo_273", Q = "_lessHeight_yxkbo_323", T = {
  amwayWhite: o,
  darkBlue: a,
  lightBlue: t,
  darkGreen: n,
  lightGreen: e,
  darkOrange: r,
  lightOrange: d,
  darkRed: i,
  lightRed: c,
  darkYellow: s,
  lightYellow: l,
  darkPurple: _,
  darkGrayOnWhite: g,
  dataVizColor1: k,
  dataVizColor2: C,
  dataVizColor3: f,
  dataVizColor3Background: z,
  dataVizColor4: V,
  dataVizColor5: b,
  dataVizColor5Background: h,
  dataVizColor6: y,
  dataVizColor7: x,
  dataVizColor8: u,
  dataVizColor8Background: m,
  dataVizColor9: B,
  dataVizColor10: O,
  dataVizColor10Background: W,
  dataVizAlertOrange: v,
  dataVizSuccessGreen: G,
  dataVizWarningRed: w,
  "no-visible": "_no-visible_yxkbo_42",
  html: I,
  contentCard: R,
  cardContainer: P,
  thumbnailContainer: Y,
  noImageContainer: p,
  noImage: F,
  offerWidth: H,
  container: A,
  content: S,
  tag: j,
  title: q,
  details: D,
  cardFooter: E,
  divider: J,
  dot: K,
  searchPage: L,
  offers: M,
  searchOverlay: N,
  lessHeight: Q,
  "skeleton-loading": "_skeleton-loading_yxkbo_1"
};
export {
  T as s
};
//# sourceMappingURL=ContentCard.module-026a7ee8.mjs.map
